import { SkeletonShape } from '@customerio/pluma-components/react';
import { themeVars } from '@customerio/pluma-components/css/theme-tokens';
import { AnimatePresence, m } from 'motion/react';
import type { SuggestionState } from './hook';
import type { ResolvedSuggestion } from './static-suggestions';
import { Suggestions } from './index';

const TRANSITION = { duration: 0.2, ease: [0.2, 0, 0.38, 0.9] } as const;

type AnimatedSuggestionChipsProps = {
  state: SuggestionState;
  /** `index` is the chip's one-based position, as analytics reports it. */
  onSuggestionClick: (message: string, index: number, suggestion: ResolvedSuggestion) => void;
};

/** The footer's suggestion chips: skeletons that morph into chips as they resolve. */
export function AnimatedSuggestionChips({ state, onSuggestionClick }: AnimatedSuggestionChipsProps) {
  const { isVisible, suggestions } = state;

  return (
    <AnimatePresence mode="popLayout">
      {isVisible
        ? suggestions.map((suggestion, index) => (
            <m.div
              key={suggestion.label}
              layout
              initial={{ opacity: 0, scale: 0.8, filter: 'blur(4px)' }}
              animate={{ opacity: 1, scale: 1, filter: 'blur(0px)' }}
              exit={{ opacity: 0, scale: 0.8, filter: 'blur(4px)' }}
              transition={{ ...TRANSITION, delay: index * 0.05 }}
            >
              <Suggestions
                suggestions={[suggestion]}
                onSuggestionClick={(message) => onSuggestionClick(message, index + 1, suggestion)}
              />
            </m.div>
          ))
        : [140, 120, 160].map((width, index) => (
            <m.div
              key={`skeleton-${index}`}
              layout
              initial={{ opacity: 0, scale: 0.8, filter: 'blur(4px)' }}
              animate={{ opacity: 1, scale: 1, filter: 'blur(0px)' }}
              exit={{ opacity: 0, scale: 0.8, filter: 'blur(4px)' }}
              transition={{ ...TRANSITION, delay: index * 0.05 }}
            >
              <SkeletonShape style={{ width, height: 29, borderRadius: themeVars.radius['4'] }} />
            </m.div>
          ))}
    </AnimatePresence>
  );
}
